export const nuwiq = [
    {
        code: "D66",
        description: "Hereditary factor VIII deficiency",
    }
]
